import React from "react";
import { Link } from "react-scroll";

function CtaBannerSection() {
  return (
    <section className="cta-banner">
      <h2>Ready to go beyond?</h2>
      <p>Book a personalised demo and see byond care in action.</p>
      <div className="cta-banner__actions">
        <Link to="demo" smooth duration={450} offset={-70} className="btn">
          Book a Demo
        </Link>
        <Link to="pricing" smooth duration={450} offset={-70} className="btn btn--light">
          See Pricing
        </Link>
      </div>
    </section>
  );
}

export default CtaBannerSection;
